<app-grid
  [columns]="gridColumnDefs" 
  [data]="gridDataForGrid" 
  [showKebabIcon]="showKebabIcon" 
  [gridConfigItems]="gridConfigItems"
  [onLoadMore]="loadMoreBinder"
  [parentComponentName]="parentComponentName"
  [searchText]="searchText"
  (searchTextChanged)="handleSearchTextChange($event)"
  (onBtnClick)="handleAddBtnClick($event)"
  (onCellClick)="handleCellClick($event)">
</app-grid>